import {} from "../node/index.js";
import {} from "./Mod.js";
import { findDefinition } from "./findDefinition.js";
export function hasNodeDefinition(mod, node) {
    const definition = findDefinition(mod, node.name);
    if (definition === undefined) {
        return false;
    }
    if (definition["@kind"] !== "NodeDefinition") {
        return false;
    }
    if (definition.mod.url.href !== node.modId) {
        return false;
    }
    return true;
}
//# sourceMappingURL=hasNodeDefinition.js.map